rs.module("controls/components/userbar",

    [
        "controls/diagnostics/debugpane",
        "controls/help/helphost",
        "controls/diagnostics/scriptlog"
    ],

    function (debugPane, help, scriptLog) {

        var _jsSelectors;
        var _cssClasses;
        var _tooltipText;

        const _hoverDelay = 400;

        // Initialize the menu
        function initialize(jsSelectors, cssClasses, tooltipText) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _tooltipText = tooltipText;

            var helpUserbarItem = $.js(_jsSelectors.helpUserbarItem, { required: false });
            var helpMenu = $.js(_jsSelectors.helpMenu, { required: false });
            var helpMenuAvailable = helpMenu.length > 0;

            var username = $.js(_jsSelectors.username);
            var userMenu = $.js(_jsSelectors.userDropDownMenu);
            var userLinks = userMenu.js(_jsSelectors.userMenuLink, { multiple: true });

            var themesMenuToggleLink = $.js(_jsSelectors.themeLink, { required: false });
            var themesMenu = $.js(_jsSelectors.themesMenu, { required: false });

            // Listen for show\hide of debug toggle only if it exists
            var debugToggle = $.js(_jsSelectors.debugToggle, { required: false });
            if (debugToggle.length > 0) {

                // Handle debug toggle clicking
                debugToggle.on("click",
                    function () {
                        debugPane.visible = !debugPane.visible;

                        _updateButtonToggle(_jsSelectors.debugToggle, debugPane.visible);
                    });

                // toggle the debug button state based on whether the debug pane is open
                _updateButtonToggle(_jsSelectors.debugToggle, debugPane.visible);
            }

            // Listen for javascript errors to display an indicator
            scriptLog.onJsError(function () {
                // Show the indicator, select with required:false because of Production mode
                $.js(jsSelectors.debugAlert, { required: false }).removeClass(cssClasses.hidden);
            });

            // Show user drop down when username is clicked
            username.click(function () {
                $(this).addClass(_cssClasses.open);
                toggleDropDown(userMenu, true);
                toggleDropDown(themesMenu, false);
            });

            // Hide user drop down when clicking outside of it
            $(document).click(function (e) {
                if (!username.is(e.target) && !username[0].contains(e.target) && !userMenu.is(e.target) && !userMenu[0].contains(e.target)) {
                    username.removeClass(_cssClasses.open);
                    toggleDropDown(userMenu, false);
                }
            });

            // close the menu when a user menu link is clicked.
            userLinks.click(function () {
                username.removeClass(_cssClasses.open);
                toggleDropDown(userMenu, false);
            });

            // close the menu when focus is tabbed out of the user menu
            userLinks.last().on("tabforward", function (e) {
                username.removeClass(_cssClasses.open);
                toggleDropDown(userMenu, false);
            });

            if (helpMenuAvailable) {
                var helpMenuToggle = $.js(_jsSelectors.helpMenuToggle);
                var helpLinks = helpMenu.js(_jsSelectors.helpMenuLink, { multiple: true });

                // Show help drop down when toggle is clicked
                helpMenuToggle.click(function () {
                    helpUserbarItem.addClass(_cssClasses.open);
                    toggleDropDown(helpMenu, true);
                });

                // Hide help drop down when clicking outside of it
                $(document).click(function (e) {
                    if (!helpMenuToggle.is(e.target) && !helpMenuToggle[0].contains(e.target) && !helpMenu.is(e.target) && !helpMenu[0].contains(e.target)) {
                        helpUserbarItem.removeClass(_cssClasses.open);
                        toggleDropDown(helpMenu, false);
                    }
                });

                // close the menu when a help link is clicked.
                helpLinks.click(function () {
                    helpUserbarItem.removeClass(_cssClasses.open);
                    toggleDropDown(helpMenu, false);
                });

                // close the menu when focus is tabbed out of the help menu
                helpLinks.last().on("tabforward", function (e) {
                    helpUserbarItem.removeClass(_cssClasses.open);
                    toggleDropDown(helpMenu, false);
                });

                // toggle field help
                $.js(_jsSelectors.helpToggle, { multiple: true }).on("click", function (e) {
                    e.stopPropagation();

                    help.visible = !help.visible;

                    // update the toggle button
                    _updateButtonToggle(_jsSelectors.helpButton, help.visible);
                    helpUserbarItem.removeClass(_cssClasses.open);
                    toggleDropDown(helpMenu, false);

                    // update tooltip and menu text
                    $.js(_jsSelectors.helpButton).attr("title", help.visible ? _tooltipText.hideFieldHints : _tooltipText.showFieldHints);
                    $.js(_jsSelectors.helpMenu).js(_jsSelectors.helpToggle).text(help.visible ? _tooltipText.hideFieldHints : _tooltipText.showFieldHints);
                });
            }

            // show hide themes menu on hover with intent
            themesMenuToggleLink.hoverIntent({
                handlerOver: function (event) { toggleDropDown(themesMenu, true); },
                handlerOut: function (event) { toggleDropDown(themesMenu, false); },
                hoverOutDelay: _hoverDelay
            });

            themesMenuToggleLink.click(function (e) {

                // if the user clicks the Themes link clear the enter timer and show themes menu immediately
                toggleDropDown(themesMenu, true);

                // prevent clicking on Themes link in the main menu from closing the drop down
                e.preventDefault();
            });

            // because of the previous line, we need to force close the menu once a theme is clicked in the themes sub menu
            themesMenu.on("click enterpressed", function (e) {
                username.removeClass(_cssClasses.open);
                toggleDropDown(userMenu, false);
            });
        }

        // Displays a toggle button as being pressed or not
        function _updateButtonToggle(selector, toggled) {
            if ($.js(selector).is("a")) {
                $.js(selector).toggleClass(_cssClasses.toggled, toggled)
            }
            else {
                $.js(selector).find("a").each(function () {
                    $(this).toggleClass(_cssClasses.toggled, toggled);
                });
            }
        }

        //
        // Toggle the visibilty of a drop down
        //
        function toggleDropDown(dropdown, visible) {
            dropdown.toggleClass(_cssClasses.visible, visible);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);